import { VFC } from "react";
import { Result, ResultProps } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

import { getResultPropsFromStatus } from "../helpers/apiResult";

interface ApiResultProps extends Omit<ResultProps, "status"> {
    status?: string | number;
    inline?: boolean;
}

const ApiResult: VFC<ApiResultProps> = ({ status, inline }) => {
    const resultProps = getResultPropsFromStatus(status);

    if (inline) {
        return (
            <div className="text-base font-medium">
                <CloseCircleOutlined className="mr-16 text-lg text-red" /> {resultProps.title} {resultProps.subTitle}
            </div>
        );
    }

    return <Result {...resultProps} />;
};

export default ApiResult;
